import * as React from "react";
import { CountDownBox, Time, CountDIcon, ImgIcon } from "./styled";

import { PoolExtraFlashInfo } from "../../../../services/product";
import { formatSecToDate } from "views/utils/flashProduct";

const CountDown = (props: {
	needIcon?: boolean;
	countInfo: PoolExtraFlashInfo;
	style?: React.CSSProperties;
	needEndsIn?: boolean;
	needIconImg?: boolean;
	iconImg?: string;
}) => {
	const {
		countInfo,
		style,
		needIcon = true,
		needEndsIn = true,
		needIconImg = false,
		iconImg = "https://tights.rightinthebox.com/tights/litb/1r3152ci5tcw0_en.png",
	} = props;
	const [endTime, setEndTime] = React.useState<number>(+(countInfo?.countdownToEnd || 0));

	const tick = () => {
		setEndTime((preTime) => {
			return preTime - 1;
		});
	};
	React.useEffect(() => {
		const timerID = setInterval(() => {
			if (endTime > 0) {
				tick();
			}
		}, 1000);
		return () => clearInterval(timerID);
	});

	if (!props?.countInfo?.countdownToEnd) {
		return null;
	}
	if (endTime <= 0) {
		return null;
	}
	const formatEndTime = formatSecToDate(endTime);
	return (
		<CountDownBox style={{ ...style }}>
			{!needIcon && needIconImg && iconImg && <ImgIcon src={iconImg} />}
			{needIcon && <CountDIcon className={countInfo?.uiOptions?.icon} />}
			<Time>{needEndsIn ? `Ends in ${formatEndTime}` : formatEndTime}</Time>
		</CountDownBox>
	);
};

export default CountDown;
